import DB from "@/common/utils/db";

/**
 * @description 获取职位派单列表
 */
export function getPositionList(query) {
  return DB({
    url: "v1/positions/grabDispatchOrderPositionViewList",
    method: "get",
    params: query
  });
}
/**
 * @description 获取人职派单列表
 */
 export function getResumePositionList(query) {
  return DB({
    url: "v1/positions/grabDispatchMatchPositionViewList",
    method: "get",
    params: query
  });
}
/**
 * @description 获取小红点
 */
 export function getUnreadCount(query) {
  return DB({
    url: "v1/positions/grabDispatchUnreadCount",
    method: "get",
    params: query
  });
}
/**
 * @description 已读未读
 */
 export function firstReadPositionBag(query) {
  return DB({
    url: "v1/positions/firstReadPositionBag",
    method: "get",
    params: query
  });
}